'use client'

import type { ReactNode } from 'react'

import { useGuideEligibility } from './use-guide-eligibility'

// Keep the route static and the guide unmounted until the server confirms
// both US geography and a non-bot BotID result.
export const UsVisitorsOnly = ({ children }: { children: ReactNode }) => {
  const eligible = useGuideEligibility()

  return eligible ? children : null
}
